import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContactDialogComponent } from '../../../contact-dialog/components/contact-dialog/contact-dialog.component';
import { UtilService, VwoService } from '../../../../shared/services';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';
@Component({
  selector: 'app-campaigner-info',
  templateUrl: './campaigner-info.component.html',
  styleUrls: ['./campaigner-info.component.scss']
})
export class CampaignerInfoComponent implements OnInit, OnChanges {

  @Input() public fundraiser: IFundraiser;
  @Input() public campaigner;
  @Input() public beneficiary;
  @Input() public contactBtn = true;
  @ViewChild('contact') public contact;
  title;
  isWL: boolean;
  showPopover;
  friendscount;
  tax

  constructor(
    public utilService: UtilService,
    public dialog: MatDialog,
    public vwo: VwoService,
    public bottomSheet: MatBottomSheet
  ) { }

  ngOnInit() {
    this.isWL = this.utilService.isWLSite();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.beneficiary) {
      this.checkTax(this.beneficiary)
    }
    if (changes.campaigner) {
      this.getRoundNumber(this.campaigner?.social?.friends_count)
    }
  }

  /**Set Name Initials  */
  setName(name) {
    return this.utilService.getInitialsOfName(name);
  }
  /**Open contact dailog */
  openDialog(template, data?, modalName?): void {
    this.title = data;
    this.dialog.open(template, {
      width: '100vw',
      maxWidth: '500px',
      maxHeight: '98vh',
      panelClass: ['round-dialog', 'about-modal']
    });
  }
  openContact(title) {
    this.dialog.open(ContactDialogComponent, {
      data: {
        title: title,
        id: this.fundraiser.id
      },
      width: '100vw',
      maxWidth: '500px',
      maxHeight: '98vh',
      panelClass: 'round-dialog'
    });
  }
  getRoundNumber(givenNumber) {
    this.friendscount =  givenNumber > 10 ? (Math.floor(givenNumber / 10)) * 10 : givenNumber;
  }
  /**Report the fundraiser */
  reportProject() {
    const url = this.utilService.domain_details.domain_url + `/support/contact-us.php?contact_ref=abuse&campaign_id=${this.fundraiser.id}`;
    this.utilService.nativeNavigation(url);
  }
  /**Check Tax exemption */
  checkTax(data) {
    if (data && data.entity_type === 'ngo') {
      this.tax = data.no_80g ? 'Tax Exemption certificate available' : 'Tax Exemption certificate not available';
    }
  }

}
